export default __webpack_public_path__ + "static/media/female developer 1---.872a53ad.svg";